import { useSwrFetch } from "./useSwrFetch";

export function useShipmentETAs(shipmentId: number | undefined) {
  const url =
    shipmentId !== undefined ? `/shipments/${shipmentId}/list-etas` : null;

  const { data, loading, error, refetch } = useSwrFetch<RoutePointETA[]>({
    url,
    errorMessage: "Failed to fetch shipment ETAs",
  });

  return {
    etas: data ?? null,
    error,
    loading,
    refetchETAs: refetch,
  };
}
